module.exports = __webpack_public_path__ + "img/bg-2.91af3e8b.jpg";